import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import cn from "classnames";
import styles from './link.module.scss';

interface LinkProps {
    className?: string
    text?: string | null;
    url?: string | null;
    underline?: boolean;
    // если передан - будет использоваться Link из react-router-dom
    routerLink?: string;
}

export const Link: React.FC<LinkProps> = ({
                                              className,
                                              text,
                                              url,
                                              underline= false,
                                              routerLink = '',
                                          }) => {
    if (!(routerLink || url) && !text) {
        return null;
    }

    const classes = cn((routerLink || url) ? styles.clickableLink : '', underline && (routerLink || url) ? styles.underline : '',styles.link, className);
    const onLinkClick = () => {
        if (url) {
            window.open(
                url,
                '_blank'
            );
        }
    };

    if (routerLink) {
        return <RouterLink className={classes} to={routerLink}>{text ? text : url}</RouterLink>
    }

    return url
        ? <a className={classes} target='_blank' href={url} rel="nofollow noreferrer">{text ? text : url}</a>
        : <div className={classes} onClick={onLinkClick}>{text ? text : url}</div>;
};
